module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./PunchClockSetView.js"));
	}, "PunchClockSetView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PunchClockSetView!./src/pages/PunchClock/PunchClockSet/PunchClockSetView.js
// module id = 1277
// module chunks = 431